import { DateTime } from 'luxon';

import { without } from '@/globals';

import * as types from './mutation-types';

const mutations = {
  [types.CREATE_LIFTDASHBOARD](state, liftDashboard) {
    state.newLiftDashboard = liftDashboard;
  },

  [types.DELETE_LIFTDASHBOARD](state, liftDashboard) {
    state.liftDashboards = without(state.liftDashboards, liftDashboard);
  },

  [types.SAVE_LIFTDASHBOARD](state, liftDashboard) {
    if (state.liftDashboards.find((c) => c.id === liftDashboard.id) === undefined) {
      state.liftDashboards = [...state.liftDashboards, liftDashboard];
    }
  },

  [types.UPDATE_LIFTDASHBOARD](state, liftDashboard) {
    if (state.liftDashboards.find((c) => c.id === liftDashboard.id) === undefined) {
      state.liftDashboards = [...state.liftDashboards, liftDashboard];
    } else {
      state.liftDashboards = [
        ...without(
          state.liftDashboards,
          state.liftDashboards.find((c) => c.id === liftDashboard.id),
        ),
        liftDashboard,
      ];
    }
  },

  [types.UPDATE_LIFTDASHBOARD_DESCRIPTION](state, change) {
    const { liftDashboard } = change;
    const newValue = change.value;
    liftDashboard.description = newValue;
    liftDashboard.modifiedOnUtc = DateTime.local();
  },

  [types.UPDATE_LIFTDASHBOARD_NAME](state, change) {
    const { liftDashboard } = change;
    const newValue = change.value;
    liftDashboard.name = newValue;
    liftDashboard.modifiedOnUtc = DateTime.local();
  },

  [types.UPDATE_LIFTDASHBOARD_PUBLIC_PLAINTEXT_PASSWORD](state, change) {
    const { liftDashboard } = change;
    const newValue = change.value;
    liftDashboard.publicPlaintextPassword = newValue;
    liftDashboard.modifiedOnUtc = DateTime.local();
  },

  [types.UPDATE_LIFTDASHBOARD_JSON](state, change) {
    const { liftDashboard } = change;
    const newValue = change.value;
    liftDashboard.json = newValue;
    liftDashboard.modifiedOnUtc = DateTime.local();
  },

  [types.UPDATE_LIFTDASHBOARDS_LIST](state, liftDashboards) {
    state.liftDashboards = liftDashboards;
  },
};

export default mutations;
